
import { Vue, Component, Prop } from "vue-property-decorator";
import RightClickMenuItem from "@/components/Canvas/OverlaidUI/Canvas/RightClickMenuItem.vue";
import Icon from "@/components/UI/Icon.vue";
import { configStore, documentStore, uiStore } from "@/store/store-accessor";

type WrapItem = {
  label: string;
  elementSlug: string;
};

@Component({
  components: {
    Icon,
    RightClickMenuItem
  }
})
export default class RightClickWrapMenu extends Vue {
  @Prop({ default: "canvas" })
  context!: "structure-panel" | "canvas";

  isInverted = false;

  get builderMode() {
    return configStore.builderMode;
  }

  get wrapItems() {
    if (this.builderMode === "oxygen") {
      return [
        {
          label: "Container",
          elementSlug: "OxygenElements\\Container"
        },
        {
          label: "Link",
          elementSlug: "OxygenElements\\ContainerLink"
        }
      ];
    }

    return [
      {
        label: "Div",
        elementSlug: "EssentialElements\\Div"
      },
      {
        label: "Link",
        elementSlug: "EssentialElements\\WrapperLink"
      }
    ];
  }

  get element() {
    return uiStore.activeElement;
  }

  get canWrap() {
    if (!this.element) return false;

    const element = configStore.element(this.element.data.type);
    const nesting = element.nestingRule.type;

    return !["section", "root", "popup"].includes(nesting);
  }

  wrapIn({ elementSlug }: WrapItem) {
    if (!this.element) return;

    documentStore.wrapElement({
      wrapperElementSlug: elementSlug,
      elementId: this.element.id
    });

    this.$emit("close");
  }

  getViewportWidth() {
    if (this.context === "canvas") {
      return window.Breakdance.canvas.document?.defaultView?.innerWidth;
    }

    return window.innerWidth;
  }

  checkOverflow() {
    this.isInverted = false;

    this.$nextTick(() => {
      const submenu = this.$refs.submenu as HTMLElement;
      if (!submenu) return;

      const rect = submenu.getBoundingClientRect();
      const viewportWidth = this.getViewportWidth();

      if (!viewportWidth) return;

      const overflow = rect.right - viewportWidth;
      const threshold = rect.width * 0.1;

      this.isInverted = overflow > threshold;
    });
  }
}
